"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getIssuer;

var _IAccount = _interopRequireDefault(require("../../../common/iObjects/IAccount"));

function getIssuer() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var visa = false,
      mc = false;

  if (value) {
    value = new _IAccount["default"](value);

    if (value.isVisa()) {
      visa = value.isCard();
    } else if (value.isMasterCard()) {
      mc = value.isCard();
    }
  }

  return {
    visa: visa,
    mc: mc
  };
}